import { gql } from "@apollo/client";

export const GET_WHO_AM_I = gql`
  {
    whoAmI {
      firstName
      lastName
      fullName
      username
      groups {
        name
      }
      displayName
      slackEmail
    }
  }
`;

export const BILLING_PORTAL = gql`
  mutation {
    billingPortal {
      billingPortal {
        portalUrl
      }
    }
  }
`;
